module.exports = __webpack_public_path__ + "89ac1bcf68fbaa55fc4080a7f56f1bc7.MP3";